module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-LightItalic-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-LightItalic-webfont.ttf
// module id = 351
// module chunks = 0